import React from 'react';
import './SkeletonCard.css';

const SkeletonCard = () => {
  return (
    <div className="skeleton-card">
      <div className="skeleton-image" />
      <div className="skeleton-text short" />
      <div className="skeleton-text long" />
      <div className="skeleton-price" />
    </div>
  );
};

export default SkeletonCard;
